export const FRAGILE_SCRIPT_URL =
  'https://script-cdn.fragile.co/fragile-nzxt.js';
